import Crud from '../views/Supplier/Crud'
import Entity from '../views/Supplier/Add'

let routes = {
    path: '/suppliers',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/suppliers/add',
            name: 'NewSupplier',
            component: Entity,
            meta: {
                pageTitle: 'Fornecedor',
                breadcrumb: [
                    { text: 'Fornecedor', active: false, to: '/suppliers' },
                    { text: 'Adicionar Fornecedor', active: true }
                ],
            },
        },
        {
            path: '/suppliers/edit/:id?',
            name: 'EditSupplier',
            component: Entity,
            meta: {
                pageTitle: 'Fornecedor',
                breadcrumb: [
                    { text: 'Fornecedor', active: false, to: '/suppliers' },
                    { text: 'Editar Fornecedor', active: true }
                ],
            },
        },
        {
            path: '/suppliers',
            name: 'list-suppliers',
            component: Crud,
            meta: {
                pageTitle: '',
                breadcrumb: [
                    { text: 'Fornecedor', active: true },
                ],
            },
        },
    ]
};

export default routes
